import { EqServiceProvider } from '@easyquery/core';
EqServiceProvider.prototype.registerDialogServiceResolver = function (resolver) {
    this['dialogServiceResolver'] = resolver;
};
EqServiceProvider.prototype.getDialogService = function () {
    if (!this['dialogService']) {
        if (!this['dialogServiceResolver']) {
            throw 'DialogServiceResolver is not defined';
        }
        this['dialogService'] = this['dialogServiceResolver']();
    }
    return this['dialogService'];
};
//# sourceMappingURL=extensions.js.map